/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../../common/themes/themes';
import CustomCard from '../../../../common/components/CustomCard';
import DropAndSelect from '../../../../common/components/DropAndSelect/DropAndSelect';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import WithdrawModalController from '../../../../common/Modals/OffboardingModal/WithdrawModal/WithdrawModalController';
import { baseDateFormatting } from '../../../../common/helper';
import { DateField } from '../../../../components';
import { useAppSelector } from '../../../../infra/hooks';

interface propsType {
  offboardingWithdrawnData: any;
  offboardingData: any;
  trans?: any;
}

const OffBoardingHistoryPresenter: React.FC<propsType> = ({
  offboardingData,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [historyData, setHistoryData] = useState<any>({});

  useEffect(() => {
    setHistoryData(offboardingData);
  }, [offboardingData]);
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);
  return (
    <CustomCard
      cardSize={{ card_title: trans('Submitted Off-Boarding') }}
      cardHeight="auto"
      cardWidth="auto"
    >
      {(historyData?.status == 4 || historyData.status == 2) && (
        <Grid
          container
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Grid
            item
            xs={2}
            style={{
              backgroundColor: '#FEECEA',
              paddingTop: '5px',
              paddingBottom: '5px',
              minWidth: '80px',
              borderRadius: '5px',
            }}
          >
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                fontSize: fonts.title,
                textAlign: 'center',
              }}
            >
              {historyData.status == 4 ? (
                <span style={{ color: themes.defaultError }}>
                  {trans('Withdrawn')}
                </span>
              ) : historyData.status == 2 ? (
                <span style={{ color: themes.defaultError }}>
                  {trans('Rejected')}
                </span>
              ) : (
                ''
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container>
        <CardContentTile
          tile_key={trans('Date of Resignation')}
          tile_value={
            <DateField
              value={historyData?.registration_date}
              format={baseDateFormatting}
            />
          }
        />
        <CardContentTile
          tile_key={trans('Last Working Day')}
          tile_value={
            <DateField
              value={historyData?.notice_date}
              format={baseDateFormatting}
            />
          }
        />
        <CardContentTile
          tile_key={trans('Reason For Resignation')}
          tile_value={historyData?.resignation_reason?.reason}
        />
        <CardContentTile
          tile_key={trans('Notice Period')}
          tile_value={
            historyData?.notice_period == 1
              ? `${historyData?.notice_period} ${trans('Day')}`
              : `${historyData?.notice_period} ${trans('Days')}`
          }
        />
        <CardContentTile
          tile_key={trans('Experience Letter')}
          tile_value={
            historyData?.experience_letter == 1 ||
            historyData?.experience_letter == 'yes'
              ? trans('Yes')
              : trans('No')
          }
        />
        <CardContentTile
          tile_key={trans('Relieving Letter')}
          tile_value={
            historyData?.revive_letter == 1 ||
            historyData?.revive_letter == 'yes'
              ? trans('Yes')
              : trans('No')
          }
        />
        <CardContentTile
          tile_key={trans('Request For Waiving Of Notice Period')}
          tile_value={
            historyData?.waive_notice_period == 1 ? trans('Yes') : trans('No')
          }
        />
        <CardContentTile
          tile_key={trans('Remarks')}
          tile_value={
            historyData?.description ? historyData?.description : '--'
          }
        />
      </Grid>

      {historyData.status == 0 ||
      historyData.status == 1 ||
      historyData.status == 2 ? (
        <Grid container style={{ marginTop: '1em' }}>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Grid container style={{ marginTop: '1em' }}>
              {historyData?.attachment && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: fonts.title,
                        color: themes.blackDefault,
                        fontWeight: 'bold',
                      }}
                    >
                      {trans('Attachments')}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: '0.5em' }}>
                    <DropAndSelect
                      src={historyData?.attachment}
                      disabledDeleteBtn={true}
                      isAttachmentSigned={true}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <>
          {historyData?.withdraw_attachment && (
            <Grid container style={{ marginTop: '1em' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attachments')}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ marginTop: '0.5em' }}>
                <DropAndSelect
                  src={historyData?.withdraw_attachment}
                  disabledDeleteBtn={true}
                />
              </Grid>
            </Grid>
          )}
        </>
      )}
      <Grid container style={{ marginTop: '1em' }}>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Grid container style={{ marginTop: '1em' }}>
            <Grid
              item
              xs={12}
              style={{
                marginTop: '1em',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {(hr_view || (!hr_view && historyData?.status === 0)) && (
                <Button
                  style={{
                    border: '1px solid #7C0E6F',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    paddingLeft: '10px',
                    paddingRight: '10px',

                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => setOpenModal(true)}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.primaryMain,
                      textTransform: 'capitalize',
                    }}
                  >
                    {trans('WITHDARAW OFF-BOARDING')}
                  </Typography>
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {openModal && (
        <WithdrawModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          selectedOffBoardingId={historyData.id}
        />
      )}
    </CustomCard>
  );
};

export default OffBoardingHistoryPresenter;
